import { FC, Fragment, PropsWithChildren, useState } from 'react';

import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';

import css from './Popconfirm.module.css';

import { Nullable, WithClassName } from 'v2/types';

interface PopconfirmProps extends WithClassName {
  message: string;
  onConfirm: VoidFunction;
  onCancel?: VoidFunction;
  confirmText?: string;
  cancelText?: string;
  disabled?: boolean;
}

export const Popconfirm: FC<PropsWithChildren<PopconfirmProps>> = ({
  className,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  disabled,
  children,
}) => {
  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  const handleCancel = () => {
    onCancel?.();
    handleClose();
  };

  return (
    <Fragment>
      <div className={className} onClick={(e) => setAnchorEl(e.currentTarget)}>
        {children}
      </div>

      {!disabled && (
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <div className={css.popconfirmContent}>
            <p className="font-medium">{message}</p>

            <div className={css.popconfirmActions}>
              <Button size="small" variant="contained" onClick={handleCancel}>
                {cancelText}
              </Button>

              <Button size="small" variant="contained" color="error" onClick={handleConfirm}>
                {confirmText}
              </Button>
            </div>
          </div>
        </Popover>
      )}
    </Fragment>
  );
};
